import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  constructor(private fs: AngularFirestore) { }

  //get records
  get() {
    return this.fs.collection("partners").snapshotChanges();
  }

  //save a record
  save(obj) {
    this.fs.collection("partners").add(JSON.parse(JSON.stringify(obj)));
  }

  //find the specified record
  find(strID) {
    return this.fs.collection("partners").doc(strID).valueChanges();
  }

  //update a record
  update(strID, obj) {
    this.fs.collection("partners").doc(strID).update(JSON.parse(JSON.stringify(obj)));
  }

  //delete a record
  delete(strID) {
    return this.fs.collection("partners").doc(strID).delete();
  }
}

